module.exports = __webpack_public_path__ + "static/media/cohere.1b685245.webp";